import initSmartOutline from "@oddcamp/js-utils/src/smart-outline";

initSmartOutline([
  "a:focus",
  "input:focus",
  "select:focus",
  "button:focus",
  "textarea:focus",
  ".choices.is-focused",
  ".choices__item.is-highlighted",
  '*[role="button"]:focus',
]);
